import { Component, ReactNode } from 'react'
import { logger } from '../utils/logger'

interface ErrorBoundaryProps {
  children: ReactNode
  fallback?: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    logger.logError(error, {
      type: 'react_error_boundary',
      componentStack: errorInfo.componentStack || ''
    })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50">
          <div className="text-center">
            <h1 className="mb-2 text-2xl font-semibold text-gray-800">
              Algo salió mal
            </h1>
            <p className="mb-4 text-gray-600">
              Ocurrió un error inesperado. Por favor, recargue la página.
            </p>
            <button
              type="button"
              className="rounded-md bg-primary px-4 py-2 text-white hover:bg-secondary"
              onClick={(): void => window.location.reload()}
            >
              Recargar página
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
